// extracted by mini-css-extract-plugin
export var text = "_af-0";